import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as organizationSelectors from '../selectors/organizationSelectors';
import routes from '../helpers/ApplicationRoutes';

export default function isAuthorizedCurrentOrganization(
    WrappedComponent,
    adminOnly = false,
) {
    class CurrentOrganizationAuthorization extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                // undefined means that resources needed to check
                // authorization are not loaded
                authorized: undefined,
            };
        }

        componentDidMount() {
            this.checkAutorization();
        }

        componentDidUpdate() {
            this.checkAutorization();
        }

        checkAutorization() {
            const {
                _organization,
                _isLoading,
                _isOrganizationAdmin,
            } = this.props;

            const { authorized } = this.state;

            if (_isLoading || authorized !== undefined) {
                return;
            }

            if (_organization) {
                if (adminOnly) {
                    this.setState({ authorized: _isOrganizationAdmin });
                } else {
                    this.setState({ authorized: true });
                }
            } else {
                this.setState({ authorized: false });
            }
        }

        render() {
            const { authorized } = this.state;
            const {
                _organization,
                _isOrganizationAdmin,
                _isLoading,
                ...rest
            } = this.props;
            if (authorized === undefined) {
                // waiting for resources to load to determine if user is authorized
                return null;
            }
            if (authorized) {
                return <WrappedComponent {...rest} />;
            }
            console.error(`Not authorized to see page ${window.location}`);
            return <Redirect to={routes.root.getPath()} />;
        }
    }

    const mapStateToProps = state => ({
        _organization: organizationSelectors.getOrganization(state),
        _isLoading: organizationSelectors.getIsLoadingOrganizations(state),
        _isOrganizationAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(
            state,
        ),
    });

    return connect(mapStateToProps)(CurrentOrganizationAuthorization);
}



// WEBPACK FOOTER //
// ./src/hoc/CurrentOrganizationAuthorization.js